import { css } from "@emotion/react";
import React from "react";

import { Alert, Text } from "@livechat/design-system-react-components";

import { config } from "config/config";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { openInNewCard } from "helpers/routing";

const banner = css`
  margin: 20px 0 0 0;
`;

export const SubscriptionBanner: React.FC = () => {
  function handleSubscribeHelpDeskClick(): void {
    trackEngagement("LC settings: Subscribe to HelpDesk button clicked", EventPlace.LiveChat);
    openInNewCard(`${config.appUrl}/subscription`);
  }

  return (
    <Alert
      kind="error"
      data-testid="subscribe-banner"
      css={banner}
      primaryButton={{
        label: "Subscribe to HelpDesk",
        handleClick: handleSubscribeHelpDeskClick,
      }}
    >
      <Text bold>Stay subscribed to HelpDesk</Text>
      <Text>Keep automating your email communications and solving customer tickets as a team in one place.</Text>
    </Alert>
  );
};
